const sustainableData = {
  'preferred-materials': {
    icon: 'preferredMaterials',
    title: {
      key: 'PDP_SUSTAINABLE_MATERIAL_TITLE',
      text: 'Preferred Materials',
    },
    subTitle: {
      key: 'PDP_SUSTAINABLE_MATERIAL_SUB_TITLE',
      text: 'Lower impact on the environment',
    },
  },
  'preferred-processes': {
    icon: 'preferredProcesses',
    title: {
      key: 'PDP_SUSTAINABLE_PROCESS_TITLE',
      text: 'Preferred Processes',
    },
    subTitle: {
      key: 'PDP_SUSTAINABLE_PROCESS_SUB_TITLE',
      text: 'Reducing the negative impact on people, animals and the planet.',
    },
  },
  'pre-loved': {
    icon: 'preLoved',
    title: {
      key: 'PDP_SUSTAINABLE_PRE_LOVED_TITLE',
      text: 'Pre-Loved',
    },
    subTitle: {
      key: 'PDP_SUSTAINABLE_PRE_LOVED_SUB_TITLE',
      text: 'One-of-a-kind vintage pieces that help support circular economy.',
    },
  },
  community: {
    icon: 'community',
    title: {
      key: 'PDP_SUSTAINABLE_COMMUNITY_TITLE',
      text: 'Community',
    },
    subTitle: {
      key: 'PDP_SUSTAINABLE_COMMUNITY_SUB_TITLE',
      text: 'Products by purpose driven brands that support people and the community.',
    },
  },
  'eco-lifestyle': {
    icon: 'ecoLifestyle',
    title: {
      key: 'PDP_SUSTAINABLE_ECO_LIFE_TITLE',
      text: 'Eco-Lifestyle',
    },
    subTitle: {
      key: 'PDP_SUSTAINABLE_ECO_LIFE_SUB_TITLE',
      text: 'Products that help you do your part to help the environment & embrace the eco-lifestyle.',
    },
  },
}

export default sustainableData
